/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBox = createReactComponent("box", "IconBox", [
  ["path", { d: "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5", key: "svg-0" }],
  ["path", { d: "M12 12l8 -4.5", key: "svg-1" }],
  ["path", { d: "M12 12l0 9", key: "svg-2" }],
  ["path", { d: "M12 12l-8 -4.5", key: "svg-3" }]
]);

export { IconBox as default };
//# sourceMappingURL=IconBox.js.map
